(() => {
  if (customElements.get('lbn-fbt')) return;
  class FrequentlyBoughtTogether extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD', currencyDisplay: 'code' });
      this.rows = Array.from(this.querySelectorAll('[data-item]')).map(element => ({ element, data: JSON.parse(element.querySelector('[data-item-json]').textContent), include: element.querySelector('[data-include]'), select: element.querySelector('[data-variant]'), touched: false }));
      this.primary = this.rows.find(row => row.element.hasAttribute('data-primary'));
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        const row = this.rows.find(row => row.element.contains(event.target));
        if (!row) return;
        if (event.target === row.select) {
          row.touched = true;
          if (row === this.primary) this.matchSizes();
        }
        this.querySelector('[data-status]').textContent = '';
        this.render();
      }, { signal: this.controller.signal });
      document.addEventListener('variant:change', event => {
        if (event.target?.getAttribute?.('id') !== this.dataset.form && event.detail?.formId !== this.dataset.form) return;
        this.primary.select.value = event.detail.variant ? String(event.detail.variant.id) : '';
        this.matchSizes(); this.render();
      }, { signal: this.controller.signal });
      this.querySelector('[data-add]').addEventListener('click', () => this.add(), { signal: this.controller.signal });
      this.matchSizes();
      this.render();
    }
    disconnectedCallback() { this.controller?.abort(); this.initialised = false; }
    variant(row) { return row.data.variants.find(variant => String(variant.id) === row.select.value); }
    format(cents) {
      if (this.money.resolvedOptions().currency !== 'AUD') return this.money.format(cents / 100);
      return this.money.formatToParts(cents / 100).map(part => part.type === 'currency' ? 'A$' : part.type === 'literal' ? '' : part.value).join('');
    }
    matchSizes() {
      const primaryVariant = this.variant(this.primary);
      for (const row of this.rows) {
        if (row === this.primary || row.touched || row.select.type === 'hidden') continue;
        const match = row.data.variants.find(variant => variant.available && variant.title === primaryVariant?.title);
        row.select.value = match ? String(match.id) : '';
      }
    }
    selection() {
      return this.rows.filter(row => row.include.checked).map(row => this.variant(row));
    }
    render() {
      for (const row of this.rows) {
        const selected = this.variant(row);
        const display = selected || row.data.variants.find(variant => variant.available) || row.data.variants[0];
        row.element.querySelector('[data-price]').textContent = this.format(display.price);
        const compare = row.element.querySelector('[data-compare]');
        compare.hidden = display.compare <= display.price;
        compare.textContent = this.format(display.compare);
        row.element.querySelector('[data-item-status]').textContent = row.include.checked && selected && !selected.available ? this.strings.unavailable : '';
        row.select.disabled = this.busy || !row.include.checked;
        row.include.disabled = Boolean(this.busy);
      }
      const selected = this.selection();
      const valid = selected.length > 0 && selected.every(variant => variant?.available);
      const total = valid ? selected.reduce((sum, variant) => sum + variant.price, 0) : 0;
      const saving = valid ? selected.reduce((sum, variant) => sum + Math.max(0, variant.compare - variant.price), 0) : 0;
      this.querySelector('[data-count]').textContent = selected.length + ' ' + (selected.length === 1 ? this.strings.item : this.strings.items);
      this.querySelector('[data-total]').textContent = valid ? this.format(total) : selected.length ? this.strings.chooseSizes : this.format(0);
      this.querySelector('[data-saving]').hidden = saving === 0;
      this.querySelector('[data-saving]').textContent = this.strings.save + ' ' + this.format(saving);
      const button = this.querySelector('[data-add]');
      button.disabled = !valid || Boolean(this.busy);
      button.textContent = this.busy ? this.strings.adding : valid ? (selected.length === 1 ? this.strings.addOne : this.strings.add).replace('[count]', selected.length) + ' · ' + this.format(total) : selected.length ? this.strings.chooseSizes : this.strings.select;
    }
    async add() {
      const selected = this.selection();
      if (this.busy || !selected.length || selected.some(variant => !variant?.available)) return;
      this.busy = true; this.render();
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: selected.map(variant => ({ id: variant.id, quantity: 1 })) })
        });
        const data = await response.json();
        if (!response.ok) {
          this.querySelector('[data-status]').textContent = (typeof data.description === 'string' ? data.description + ' ' : '') + this.strings.rejected;
          this.querySelector('[data-cart-link]').hidden = false;
          this.querySelector('[data-add]').textContent = this.strings.unavailable;
          return;
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.querySelector('[data-status]').textContent = this.strings.unknown;
        this.querySelector('[data-cart-link]').hidden = false;
        this.querySelector('[data-add]').textContent = this.strings.unavailable;
      }
    }
  }
  customElements.define('lbn-fbt', FrequentlyBoughtTogether);
})();
